"use strict";
import React, { forwardRef } from "react";
import { Text, TouchableOpacity, View } from "react-native";
import { Avatar, Image } from "react-native-elements";
import Modal from "react-native-modalbox";
import { useDispatch } from "react-redux";
import commonStyles from "../styles/commonStyles";
import { openBrowser } from "../utils/UrlUtil";
import { t } from "../services/i18n";

const MediaModal = forwardRef(({ onClosed = () => {} }, messageModal) => {
	const {
		bgLightgrey,
		bgColor2,
		bgBlack,
		bgRed,
		color2,
		row,
		flex1,
		justifyContentCenter,
		alignItemsCenter,
		mb10,
		mv10,
		mh10,
		p5,
		pr10,
		font,
		fontBold,
		rounded30,
		h60,
		overflowHidden,
		gap10,
		mb20
	} = commonStyles;
	const dispatch = useDispatch();

	return (
		<Modal
			backdrop={true}
			backdropOpacity={0.7}
			backdropColor="black"
			position="center"
			style={[rounded30, { width: 300, height: 280 }]}
			ref={messageModal}
			onClosed={onClosed}
			swipeToClose
			backdropPressToClose
		>
			<View style={[mv10, flex1]}>
				<View style={flex1}>
					<View
						style={[
							bgLightgrey,
							row,
							h60,
							rounded30,
							alignItemsCenter,
							pr10,
							mb20,
							mh10
						]}
					>
						<Avatar
							rounded
							size={60}
							overlayContainerStyle={bgColor2}
							icon={{ name: "link", type: "font-awesome" }}
							activeOpacity={0.7}
						/>
						<View contentContainerStyle={[justifyContentCenter, flex1]}>
							<Text style={[fontBold, { fontSize: 16 }, color2, p5]}>
								{"MEDIA"}
							</Text>
						</View>
					</View>
					<View style={[mh10, alignItemsCenter]}>
						<Text style={[font, mb10]}>{t("template:copyurl")}</Text>
						<View style={{ flexDirection: "column" }}>
							<TouchableOpacity
								style={[row, gap10, alignItemsCenter, mb10]}
								onPress={() => {
									messageModal?.current?.close();
									openBrowser(dispatch, "https://www.youtube.com");
								}}
							>
								<View
									style={[
										bgRed,
										rounded30,
										alignItemsCenter,
										justifyContentCenter,
										overflowHidden,
										{ width: 60, height: 60 }
									]}
								>
									<Image
										source={require("../assets/images/youtube.png")}
										style={{ width: 60, height: 60 }}
									/>
								</View>
								<Text style={[font]}>{"Youtube"}</Text>
							</TouchableOpacity>
							<TouchableOpacity
								style={[row, gap10, alignItemsCenter, mb10]}
								onPress={() => {
									messageModal?.current?.close();
									openBrowser(
										dispatch,
										"https://giphy.com/search/neighborhood"
									);
								}}
							>
								<View
									style={[
										bgBlack,
										rounded30,
										alignItemsCenter,
										justifyContentCenter,
										overflowHidden,
										{ width: 60, height: 60 }
									]}
								>
									<Image
										source={require("../assets/images/giphy.png")}
										style={{ width: 50, height: 50 }}
									/>
								</View>
								<Text style={[font]}>{"Giphy"}</Text>
							</TouchableOpacity>
						</View>
					</View>
				</View>
			</View>
		</Modal>
	);
});

export default MediaModal;
